import { GridColumnConfig } from '../../../models/gridCoumnConfig';

export const columns: GridColumnConfig[] = [
  {
    title: 'Municipality Name',
    field: 'muncipalityName',
    filter: 'text',
    searchable: true,
    navigate: true,
  },
  {
    title: 'Code',
    field: 'municipalityCode',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Cut-off Time',
    field: 'cutOffTime',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'State',
    field: 'state',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Status',
    field: 'status',
    filter: 'text',
  },
];
